import React from "react";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import QuickContact from "../resuables/quick-contact";

function Pagenotfound() {
  return (
    <div>
      {/* <QuickContact/> */}
      <Navbar />
      <div className="pagenotfound">Page not found</div>
      <Footer />
    </div>
  );
}

export default Pagenotfound;
